import MessageBusTopics from '../../common/MessageBusTopics';

export const trackLink = (element) => new Promise((resolve) => {
    const trackingEvent = element.getAttribute('data-link-trk-event');

    if (trackingEvent) {
        const trackingData = {};
        const trackingPrefix = 'linkTrk';
        
        for (const key in element.dataset) if(
            element.dataset.hasOwnProperty(key) &&
            key.startsWith(trackingPrefix) &&
            key !== 'linkTrkEvent'
        ) {
            trackingData[key.slice(trackingPrefix.length)] = element.dataset[key];
        }

        window.WH.messageBus.publish(MessageBusTopics.TRACKING_EVENT_PARTIAL, {
            event: trackingEvent,
            payload: trackingData,
        });

        setTimeout(resolve, 500);
    } else {
        resolve();
    }
});